__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "kdesigns";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query-devtools", "5.91.1", () => (__webpack_require__.e(184).then(() => (() => (__webpack_require__(6184))))));
			register("@tanstack/react-query", "5.90.12", () => (__webpack_require__.e(40).then(() => (() => (__webpack_require__(2040))))));
			register("axios", "1.6.7", () => (__webpack_require__.e(418).then(() => (() => (__webpack_require__(9418))))));
			register("date-fns", "2.30.0", () => (Promise.all([__webpack_require__.e(853), __webpack_require__.e(494)]).then(() => (() => (__webpack_require__(9853))))));
			register("quill", "1.3.7", () => (__webpack_require__.e(574).then(() => (() => (__webpack_require__(1574))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(961))), 1);
			register("react-router-dom", "6.14.2", () => (() => (__webpack_require__(2648))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(6540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};